export default __webpack_public_path__ + "static/media/about-img.52fafaea.png";